
import {
  Component, Mixins, Prop,
} from 'vue-property-decorator';
import moment from 'moment';
import InstallationDateMixin from '@/mixins/InstallationDateMixin.vue';
import { Connection, TaskStatus } from '@/types';

moment.locale('it');

@Component
export default class ConnectionInstallationDate extends Mixins(InstallationDateMixin) {
  @Prop(Object) readonly connection!: Connection;

  // get partialInstallationDate(): string | null {
  //   return this.connection?.partialInstallationDate
  //     && moment(this.connection.partialInstallationDate).isValid()
  //     ? moment(this.connection.partialInstallationDate).format('L')
  //     : null;
  // }

  get partialInstallationDate(): string | null {
    if (this.partialInstallationDateMode === 'single') {
      return this.connection?.partialInstallationDate
        && moment(this.connection.partialInstallationDate).isValid()
        ? moment(this.connection.partialInstallationDate).format('DD/MM/YYYY')
        : null;
    }

    // 'week'
    return this.connection?.partialInstallationDate
      && moment(this.connection.partialInstallationDate).isValid()
      ? `WW ${moment(this.connection.partialInstallationDate).format('WW-GGGG')}`
      : null;
  }

  // get installationDate(): string | null {
  //   return this.connection?.installationDate
  //     && moment(this.connection.installationDate).isValid()
  //     ? moment(this.connection.installationDate).format('L')
  //     : null;
  // }

  get installationDate(): string | null {
    if (this.installationDateMode === 'single') {
      return this.connection?.installationDate
        && moment(this.connection.installationDate).isValid()
        ? moment(this.connection.installationDate).format('DD/MM/YYYY')
        : null;
    }

    // 'week'
    return this.connection?.installationDate
      && moment(this.connection.installationDate).isValid()
      ? `WW ${moment(this.connection.installationDate).format('WW-GGGG')}`
      : null;
  }

  get installationTaskStatus(): TaskStatus {
    return this.connection?.installationTaskStatus;
  }

  get installationDateMode(): 'single' | 'week' {
    // Modalità di visualizzazione della data (settimanale di default)
    return this.connection?.installationDateMode ?? 'week';
  }

  get installationDateConfirm(): boolean {
    return this.connection?.installationDateConfirm === true;
  }

  get installationCompleted(): boolean {
    return this.connection?.installationCompleted === true;
  }

  get partialInstallationCompleted(): boolean {
    return this.connection?.partialInstallationCompleted === true;
  }

  get partialInstallationDateMode(): 'single' | 'week' {
    // Modalità di visualizzazione della data (settimanale di default)
    return this.connection?.partialInstallationDateMode ?? 'week';
  }

  get partialInstallationDateConfirm(): boolean {
    return this.connection?.partialInstallationDateConfirm === true;
  }

  get installationNotes(): string | null {
    return this.connection?.installationNotes ?? null;
  }

  // FIXME: "Portare fuori" le prime due condizioni per generalizzare il getter
  get columnClass(): string {
    if (this.installationTaskStatus === 'completed') return 'green';
    if (this.installationTaskStatus === 'error') return 'red';

    if (this.installationCompleted) return 'completed';
    if (this.installationDateConfirm) return this.partialInstallationCompleted ? 'yellow-green' : 'yellow';

    if (this.partialInstallationCompleted) return 'white-green';
    if (this.partialInstallationDateConfirm) return 'white-yellow';

    return '';
  }
}
